module.exports = __webpack_public_path__ + "img/careers-work-at-hero.jpg?a96e23c5e98d8b507f598ca056d9f76a";